export * from './search-fan.component';
